import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {observer} from 'mobx-react';

interface ConnectedDevicesBoxProps {
    networkDiscoveryDevice: any;
    key: number;
}

@observer
export class ConnectedDevicesBox extends TechseeBaseComponent<ConnectedDevicesBoxProps> {
    renderVectorIcon() {
        return (
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M11 3.22998C11 2.58998 10.41 2.09998 9.79001 2.23998C8.67001 2.49998 7.61001 2.93998 6.67001 3.53998C6.14001 3.87998 6.06001 4.63998 6.51001 5.08998C6.83001 5.40998 7.34001 5.48998 7.72001 5.24998C8.49001 4.75998 9.34001 4.39998 10.26 4.19998C10.7 4.09998 11 3.68998 11 3.22998ZM17.33 3.54998C16.39 2.94998 15.33 2.50998 14.21 2.24998C13.59 2.10998 13 2.58998 13 3.22998C13 3.67998 13.3 4.09998 13.74 4.18998C14.65 4.38998 15.51 4.75998 16.27 5.23998C16.66 5.47998 17.16 5.40998 17.48 5.07998C17.94 4.63998 17.87 3.88998 17.33 3.54998ZM20.77 11C21.41 11 21.9 10.41 21.76 9.78998C21.5 8.66998 21.06 7.60998 20.46 6.66998C20.12 6.13998 19.36 6.05998 18.91 6.50998C18.59 6.82998 18.51 7.33998 18.75 7.71998C19.24 8.48998 19.6 9.33998 19.8 10.25C19.9 10.7 20.31 11 20.77 11ZM5.10001 6.50998C4.64001 6.05998 3.89001 6.12998 3.55001 6.66998C2.95001 7.60998 2.51001 8.66998 2.25001 9.78998C2.11001 10.41 2.59001 11 3.23001 11C3.68001 11 4.10001 10.7 4.19001 10.26C4.39001 9.34998 4.76001 8.48998 5.24001 7.72998C5.50001 7.33998 5.42001 6.82998 5.10001 6.50998ZM3.23001 13C2.59001 13 2.10001 13.59 2.24001 14.21C2.50001 15.33 2.94001 16.38 3.54001 17.33C3.88001 17.87 4.64001 17.94 5.09001 17.49C5.41001 17.17 5.49001 16.66 5.24001 16.28C4.75001 15.52 4.39001 14.67 4.19001 13.75C4.10001 13.3 3.69001 13 3.23001 13ZM15 12C15 10.34 13.66 8.99998 12 8.99998C10.34 8.99998 9.00001 10.34 9.00001 12C9.00001 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12ZM18.9 17.49C19.35 17.94 20.11 17.87 20.45 17.34C21.05 16.4 21.49 15.34 21.75 14.23C21.89 13.61 21.4 13.02 20.77 13.02C20.32 13.02 19.9 13.32 19.81 13.76C19.61 14.67 19.24 15.52 18.76 16.29C18.5 16.66 18.58 17.17 18.9 17.49ZM13 20.77C13 21.41 13.59 21.9 14.21 21.76C15.33 21.5 16.38 21.06 17.33 20.46C17.87 20.12 17.94 19.36 17.49 18.91C17.17 18.59 16.66 18.51 16.28 18.76C15.52 19.25 14.67 19.61 13.75 19.81C13.3 19.9 13 20.31 13 20.77ZM6.67001 20.45C7.62001 21.05 8.67001 21.49 9.79001 21.75C10.41 21.89 11 21.4 11 20.77C11 20.32 10.7 19.9 10.26 19.81C9.35001 19.61 8.49001 19.24 7.73001 18.76C7.34001 18.52 6.84001 18.59 6.52001 18.92C6.06001 19.36 6.13001 20.11 6.67001 20.45Z'
                    fill='black'
                    fillOpacity='0.54'
                />
            </svg>
        );
    }

    renderDeviceOutlineIcon() {
        return (
            <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M2.66667 4.00002H14.6667V2.66669H2.66667C1.93333 2.66669 1.33333 3.26669 1.33333 4.00002V11.3334H0V13.3334H9.33333V11.3334H2.66667V4.00002ZM15.3333 5.33335H11.3333C10.9667 5.33335 10.6667 5.63335 10.6667 6.00002V12.6667C10.6667 13.0334 10.9667 13.3334 11.3333 13.3334H15.3333C15.7 13.3334 16 13.0334 16 12.6667V6.00002C16 5.63335 15.7 5.33335 15.3333 5.33335ZM14.6667 11.3334H12V6.66669H14.6667V11.3334Z'
                    fill='#6B7280'
                />
            </svg>
        );
    }

    renderInternal() {
        const {networkDiscoveryDevice} = this.props;

        return (
            <>
                <div className='wifi-analyzer-device-box-container'>
                    <div className='wifi-analyzer-device-rounded-icon'>{this.renderVectorIcon()}</div>

                    <div className='wifi-analyzer-device-box-middle-container'>
                        <div className='wifi-analyzer-device-box-middle'>
                            <p className='wifi-analyzer-device-box-middle-header' title={networkDiscoveryDevice.name}>
                                {networkDiscoveryDevice.name}
                            </p>
                            <div className='wifi-analyzer-device-info'>
                                <div className='wifi-analyzer-device-box-icon'>{this.renderDeviceOutlineIcon()}</div>
                                <p className='wifi-analyzer-device-box-info-text'>{networkDiscoveryDevice.model}</p>
                                <p className='wifi-analyzer-device-box-info-text'>
                                    {networkDiscoveryDevice.manufacturer}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='wifi-analyzer-device-box-right'>
                        <p className='wifi-analyzer-device-box-info-text'>{networkDiscoveryDevice.ip}</p>
                    </div>
                </div>
                <div className='wifi-analyzer-device-box-underline' />
            </>
        );
    }
}
